import { TemplateConfig } from '../types';

export const soulmate3CardsConfig: TemplateConfig = {
  id: 'soulmate-3-cards',
  name: '正缘3张牌',
  description: '分析你的正缘基本情况',
  cardCount: 3,
  
  fieldDefaults: {
    title: '我的正缘分析',
    customerQuestion: '**我未来的正缘的情况分析**',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 1 行第 2 张牌',
      '请输入第 1 行第 3 张牌'
    ],
    cardInfos: [
      '未来正缘的性格',
      '未来正缘的外貌和身高信息，分析时请尽量具体，如：肤色偏白、身高175左右、瓜子脸之类',
      '未来正缘的工作情况和职业类型，分析时即使目前看起来这方面信息不明显，也要给出具体的专业或行业范围，如：金融行业、计算机专业等'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#9254de',
    backgroundColor: '#f9f0ff',
    icon: '💝'
  },

  spreadLayout: {
    coordinate: 'normalized',
    cardSize: {
      widthRatio: 0.25,
      heightRatio: 0.65875,
      anchor: 'center'
    },
    positions: [
      { x: 0.2, y: 0.5 },
      { x: 0.5, y: 0.5 },
      { x: 0.8, y: 0.5 }
    ]
  }
};
